export const FETCHER_OPTS = {
  locale: 'en-US',
  reporting: {
    moduleID: 'axp-travel-credit',
    componentID: 'HotelCreditModal',
  },
};

export const MEMBERSHIP_QUERY = `
query TravelCredit {
  membership(type: JWT_TOKEN) {
    accountToken
    travelCredits {
      awardName
    }
    demographics {
      isTopCard
    }
  }
}
`;
